import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';
import { Product } from '@df/catalog/product/product';
import { DfEventService } from '@df/core/service/df-event';
import { TimeoutService } from '@df/ng/timeout.service';
import { GtmItemDirective } from './gtm-item.directive';

/**
 * GTM list directive
 */
@Directive({
    selector: '[gtmItemLink]',
    standalone: true
})
export class GtmItemLinkDirective {
    @Input()
    gtmItemLink; // that is expected to be void

    /**
     * Access to parent directive
     */
    private gtmItemDirective = inject(GtmItemDirective);

    /**
     * Event service
     */
    private dfEventService = inject(DfEventService);

    /**
     * Event service
     */
    // private timeoutService = inject(TimeoutService);
    private elementRef = inject(ElementRef);

    /**
     * Bind redirects on click
     */
    @HostListener('click')
    dispatchProductClickEvent() {
        this.dfEventService.dispatch({
            id: 'dfGtmItemLinkClick',
            data: this.gtmItemDirective.getEventData()
        });
    }
}
